import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {ApiCall, GetApiCall} from "../../helper/axios";
import { getCookie } from '../../helper/commonFunction';

// Parse cookie data - handle both JSON string and object
let cookieData = {};
try {
    const cookieValue = getCookie("dahrToursUserMenu");
    if (cookieValue) {
        cookieData = typeof cookieValue === 'string' ? JSON.parse(cookieValue) : cookieValue;
    }
} catch (e) {
    // If parsing fails, use empty object
    cookieData = {};
}

const initialState = {
    userAgentLoader : true,
    userAgentData: {},
    agentActiveCurrency : 'AED',
    displayPrice : 0,
    recentSearchData : [],
    recentSearchLoader : true,
    headerAnnounceData : [],
    userNotificationData : [],
    airlineCompanyList : [],
    hotelCompanyList : [],
    onineServicesFees : null,
    walletBalance : null,
    showVendorLogo : false,
    seatShow : false,
    isShowMarkupOption: false,
    isShowFlightAlternateOption: false,
    headerMenu : {
        "visa-change-by-flight": cookieData?.['visa-change-by-flight'] ?? true,
        "visa-change-by-bus":cookieData?.['visa-change-by-bus'] ?? true,
        "insurance":cookieData?.['insurance'] ?? true,
        "global-visa":cookieData?.['global-visa'] ?? true,
        "loyalty-points":cookieData?.['loyalty-points'] ?? true,
        "hotel-dummy-voucher":cookieData?.['hotel-dummy-voucher'] ?? true,
        "excursion-tickets":cookieData?.['excursion-tickets'] ?? true,
        "flight-booking":cookieData?.['flight-booking'] ?? true,
        "hotel-booking":cookieData?.['hotel-booking'] ?? true,
        "car-transfer":cookieData?.['car-transfer'] ?? true
    },
    ndcData : null,
    isHotel : false,
    isCar : false,
    agentName : "",
    onlinePaymentEnable : false,
    userKyc : true,
    flightMarkupAmount : 0,
};

export const getUserData = createAsyncThunk('fetch/user-data', async (userId) => {
    const res = await GetApiCall('GET', `wp-json/dahr/v1/user-details?token=${userId}`,{},'wordpress');
    if (res?.status === 200) {
        return res?.data;
    }
    throw new Error('Failed to fetch getUserData data');
});

export const getUserRecentData = createAsyncThunk('fetch/user-recent-data', async (userToken) => {
    const res = await ApiCall('POST', `/flights/recent-search`,{}, {authorization : userToken });
    if (res?.status === 200) {
        return res?.data;
    }
    throw new Error('Failed to fetch getUserData data');
});

const userSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setCommonUserData: (state, action) => {
            state.userData = action.payload;
        },
        setAgentActiveCurrency : (state, action) => {
            state.agentActiveCurrency = action.payload;
        },
        setWalletBalance : (state, action) => {
            state.walletBalance = action.payload;
        },
        setndcData: (state,action) => {
            state.ndcData = action.payload
        },
        setFlightMarkupAmount: (state, action) => {
            const nextMarkup = Number(action.payload);
            state.flightMarkupAmount = Number.isFinite(nextMarkup) && nextMarkup > 0 ? nextMarkup : 0;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserData.pending, (state) => {
                state.userAgentLoader = true;
            })
            .addCase(getUserData.fulfilled, (state, { payload }) => {
                state.userAgentLoader = false;
                state.userAgentData = payload;
                state.airlineCompanyList = payload?.user_data?.flight_vendor;
                {
                    const hv = payload?.user_data?.hotel_vendor;
                    state.hotelCompanyList = Array.isArray(hv)
                        ? hv.map((v) => String(v).toUpperCase())
                        : (hv ? String(hv).split(",").map((v) => v.trim().toUpperCase()).filter(Boolean) : []);
                }
                state.showVendorLogo = payload?.user_data?.vendor_logo;
                state.seatShow = payload?.user_data?.seatShow === true
                    || payload?.user_data?.seatShow === 1
                    || payload?.user_data?.seatShow === '1'
                    || payload?.user_data?.seatShow === 'true';
                state.isShowMarkupOption = payload.isShowMarkupOption === true
                    || payload?.isShowMarkupOption === 1
                    || payload?.isShowMarkupOption === '1'
                    || payload?.isShowMarkupOption === 'true';
                state.isShowFlightAlternateOption = payload?.isShowFlightAlternateOption === true
                    || payload?.isShowFlightAlternateOption === 1
                    || payload?.isShowFlightAlternateOption === '1'
                    || payload?.isShowFlightAlternateOption === 'true';
                state.onineServicesFees = payload?.onineServicesFees;
                state.displayPrice = payload?.displayPrice;
                state.onlinePaymentEnable = payload?.onlinePaymentEnable;
                state.headerAnnounceData = payload?.announcements || [];
                state.userNotificationData = payload?.notifications || [];
                state.isHotel = payload?.user_data?.is_hotel;
                state.isCar = payload?.user_data?.is_car;
                // Update headerMenu from API if available, otherwise keep existing cookie-based data
                if (payload?.user_data?.header_menu) {
                    state.headerMenu = payload.user_data.header_menu;
                }
                state.agentName = payload?.user_data?.profile_char
                state.userKyc = payload?.userKyc
            })
            .addCase(getUserData.rejected, (state) => {
                state.userAgentLoader = false;
                window.location.href = process.env.wordpressApiEndPoint;
            })
            .addCase(getUserRecentData.pending, (state) => {
                state.recentSearchLoader = true;
            })
            .addCase(getUserRecentData.fulfilled, (state, { payload }) => {
                state.recentSearchLoader = false;
                state.recentSearchData = payload?.data?.searchData || [];
            })
            .addCase(getUserRecentData.rejected, (state) => {
                state.recentSearchLoader = false;
            })
    },
});

export const { setCommonUserData, setAgentActiveCurrency, setWalletBalance , setndcData, setFlightMarkupAmount } = userSlice.actions;
export default userSlice.reducer;
